import script from "./MovimientosView.vue?vue&type=script&setup=true&lang=js"
export * from "./MovimientosView.vue?vue&type=script&setup=true&lang=js"

import "./MovimientosView.vue?vue&type=style&index=0&id=604acb5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604acb5d"]])

export default __exports__